import * as actionType from "./cmsActionType";

const initialState = {
  isLoading: false,
  cms: {}
};

export const cmsReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionType.FETCH_CMS:
            return {
                ...state,
                isLoading: true,
            };
        case actionType.FETCH_CMS_FAILURE:
            return {
                ...state,
                isLoading: false,
            };
        case actionType.FETCH_CMS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                cms: action.payload ? action.payload.data : {},
            };
        default:
            return state;
    }
}